import { OrganisationUnit } from '@app/models';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useRawGetOrganisationHierarchy } from './UseRawGetOrganisationHierarchy';

export function useOrganisationUnitsWithProducts() {
  function getOusWithProducts(organisationUnit: OrganisationUnit): OrganisationUnit[] {
    let result: OrganisationUnit[] = [];
    if (organisationUnit.products.length > 0) {
      result.push(organisationUnit);
    } else {
      organisationUnit.children.forEach((child) => (result = result.concat(getOusWithProducts(child))));
    }
    return result;
  }

  const getOrganisationHierarchy = useRawGetOrganisationHierarchy();
  return useQueryWithErrorHandling({
    queryKey: ['organisation-hierarchy'],
    queryFn: getOrganisationHierarchy,
    select: (tenantHierarchy) => getOusWithProducts(tenantHierarchy.organisationUnit),
  });
}
